import { render, staticRenderFns } from "./InitiateProcess1.vue?vue&type=template&id=d2bca7cc&scoped=true&"
import script from "./InitiateProcess1.vue?vue&type=script&lang=js&"
export * from "./InitiateProcess1.vue?vue&type=script&lang=js&"
import style0 from "./InitiateProcess1.vue?vue&type=style&index=0&id=d2bca7cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bca7cc",
  null
  
)

export default component.exports